module.exports = __webpack_public_path__ + "static/media/boxes.c32c4258.jpg";